import request, { CommonListResponse, IListWorkspaceResponse, IPage, IWorkspaceResponse } from '/@/api/http/request'
const HTTP_PREFIX = '/app/api/v1'
const HTTP_PREFIX_MANAGE = '/manage/api/v1'
// 获取字典
export const getDataDict = async function (): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX_MANAGE}/dataDict/getDataDict`
  const result = await request.get(url)
  return result.data
}
// 获取字典id树状
export const getDataDictTreeById = async function (id:Number): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX_MANAGE}/dataDict/getDataDictTreeById/${id}`
  const result = await request.get(url)
  return result.data
}
export const getSystemConfig = async function (id:Number): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/dataDict/getSystemConfig/${id}`
  const result = await request.get(url)
  return result.data
}
// 添加字典
export const addDataDict = async function (data:{}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX_MANAGE}/dataDict/addDataDict`
  const result = await request.post(url, data)
  return result.data
}
// 更新字典
export const updateDataDict = async function (data:{}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX_MANAGE}/dataDict/updateDataDict`
  const result = await request.post(url, data)
  return result.data
}
// 删除字典
export const deleteDataDictById = async function (id:string): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX_MANAGE}/dataDict/deleteDataDictById/${id}`
  const result = await request.get(url)
  return result.data
}
